import { useSelector } from "react-redux";
import {
  selectCurrentEventId,
  selectEventCompanyId,
} from "modules/event/selectors";
import { selectMyCompany } from "modules/company/redux/selectors";
import { firebaseAuth } from "services/firebaseService/firebaseConfig";
import { selectAuth } from "../redux/selectors";

type UseAuthFlagsValues = {
  isAuthenticated: boolean;
  isAnonymous: boolean | undefined;
  isActualAdmin: boolean;
  isActualManager: boolean;
  isCompanyOwnerInOwnEvent: boolean;
};

const useAuthFlags = (): UseAuthFlagsValues => {
  const isAuthenticated = !!firebaseAuth.currentUser;
  const { user, isAdmin, isManager } = useSelector(selectAuth);
  const isAnonymous = isAuthenticated && firebaseAuth.currentUser?.isAnonymous;
  const currentEventId = useSelector(selectCurrentEventId);
  const eventCompanyId = useSelector(selectEventCompanyId);
  const company = useSelector(selectMyCompany);

  const isSameCompanyEventUser =
    (currentEventId && eventCompanyId) === (company && company.id); // true possible only for admin and manager
  const isManagerAndNotInEvent = isManager && !currentEventId; // company manager in dashboard

  const isActualManager =
    isManagerAndNotInEvent || (isManager && isSameCompanyEventUser); // manager in dashboard or manager in event of his company
  const isCompanyAdmin = company && company.owner === (user && user.id); // company owner
  const isCompanyOwnerInOwnEvent = Boolean(
    isCompanyAdmin && isSameCompanyEventUser,
  ); // company owner in event which belongs to his company
  const isActualAdmin = Boolean(
    isAdmin ||
      isCompanyOwnerInOwnEvent ||
      (isSameCompanyEventUser && isManager) || // company manager in event which belongs to his company
      (isCompanyAdmin && !currentEventId),
  ); // company owner in dashboard

  return {
    isAuthenticated,
    isAnonymous,
    isActualAdmin,
    isActualManager,
    isCompanyOwnerInOwnEvent,
  };
};

export default useAuthFlags;
